import { FinalCausalityListProps } from './props';
import { useFinalCausalityList } from './hook';
import { Table } from '../../../../components/general/table';
import { FINAL_CAUSALITY_DETAIL } from '../../../../../routes/paths';

export const FinalCausalityList = ({ filters }: FinalCausalityListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useFinalCausalityList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(
                    `${FINAL_CAUSALITY_DETAIL}/${item.row.id}`,
                    '_blank'
                )
            }
        />
    );
};
